import VerticalCenter from "../common/components/VerticalCenter";
import AudioFlower from "../common/components/AudioFlower";
import Center from "../common/components/Center";

export default function Scene2Story1() {
  return (
    <VerticalCenter>
      <Center>
        <AudioFlower animate />
      </Center>
    </VerticalCenter>
  );
}
